(($)=>{
    "use strict";

    if(!window.ESRBMembers || ! window.ESRBMembers.member_id){
        return
    }
    const ESRBMembers = window.ESRBMembers;
    const cookieName = 'MemberEndorsed' + '_' + ESRBMembers.member_id;

    const $btn = $('.endorse-this-member');
    const $counter = $('#member-counter');

    if(!$btn.length || !$counter.length){
        return;
    }

    function setCookie(name, value, expireDays) {

        const options = {
            path: '/'
        };
        const expires = new Date();
        expires.setDate(expires.getDate() + expireDays);

        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        value = encodeURIComponent(value);

        let updatedCookie = name + '=' + value;

        for (let propName in options) {
            updatedCookie += '; ' + propName;
            let propValue = options[propName];
            if (propValue !== true) {
                updatedCookie += '=' + propValue;
            }
        }

        document.cookie = updatedCookie;
    }
    function getCookie(name) {
        const matches = document.cookie.match(new RegExp(
            '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }


    if( getCookie(cookieName) &&  getCookie(cookieName) === ESRBMembers.member_id){
        $btn.remove();
        return;
    }

    // lets check cookie

    // lets make ajax call
    $btn.on('click', function endorseThisMember(event){


        if(!$btn.hasClass('done')){

            $btn.addClass('done');

            let currentCounter = parseInt($counter.text());

            currentCounter++;
            // display it immediately and then refresh.
            $counter.text(currentCounter);

            let data = {
                action: 'endorseThisMember',
                _ajax_nonce: ESRBMembers._ajax_nonce,
                id: ESRBMembers.member_id
            };

            $btn.css({overflow: 'hidden'});
            $btn.animate({opacity: 0, height: 0},500,'swing', function(){
                $btn.remove();
            });

            $.ajax({
                url: ESRBMembers.ajaxurl,
                data: data,
                type: 'POST',
                success: (result) => {
                    if (result && result.data && result.data.counter) {

                        $counter.text(result.data.counter);

                    }

                    setCookie(cookieName, ESRBMembers.member_id, 7);
                },
                fail: (err) => {
                    console.error(err);
                    $btn.remove();
                }
            });

        }

         event.preventDefault();

    });


})(jQuery);